import React, {Component} from 'react';
import PubSub from 'pubsub-js'
import InputGroup from 'react-input-groups';
import './index.css'
import 'react-input-groups/lib/css/styles.css'
import imgCodeAlert from "../BsyAlertImgCode/Staticize";

class EntryInputCode extends Component {

    constructor(props) {
        super(props);
        this.state={
            value:{
                accountType:'',
                countryCode:'',
                value:''
            },
            errorMsg: "",
            clickSend:false
        }
        this.pubsub_token=PubSub.subscribe("codeCont",(topic,value)=>{
            this.setState({...value,time:60,clickSend:false})
            this.timer=setInterval(()=>{
                let time=this.state.time - 1
                this.setState({time:time})
                if(this.state.time <=0){
                    clearInterval(this.timer)
                    this.setState({clickSend:true})
                }
            },1000)
        })
    }

    componentDidMount() {
        document.getElementsByClassName("box-input")[0].focus()
    }

    componentWillUnmount() {
        clearTimeout(this.timer1)
        clearInterval(this.timer)
        PubSub.unsubscribe(this.pubsub_token);
    }

    onBackClick = () => {
        this.props.changeContCodePage && this.props.changeContCodePage("LoginCodeShow")
    }

    render() {
        const {LoginCode, mode} = this.props
        const {value, accountType, countryCode} = this.state.value
        const {clickSend, errorMsg} = this.state
        return (
            <div className='EntryInputCode'>
                <div className="codeTitle">
                    <i className="icon-bsy-left" onClick={this.onBackClick}></i>
                    <span>{React.language('entry.code.tip',{len:4})}</span>
                </div>
                <div className="codeTip">
                    <span>{React.language('code.sent.to') + (accountType==="mobile"?React.language('widget.phone'):React.language('email'))}</span>
                    <span className="text">{accountType==="mobile"?`+${countryCode + value}`:`${value}`}</span>
                </div>
                <div className={`check-code${!!errorMsg ? " error" : ""}`}>
                    <div className="code-error">
                        {errorMsg}
                    </div>
                    <InputGroup
                        getValue={(values)=>{
                            this.setState({errorMsg: ""})
                            if(values.length>=4){
                                LoginCode(values, this.state.value, (isError, msg)=>{
                                    this.setState({errorMsg: isError ? msg : ""})
                                })
                            }
                        }}
                        length={4}
                        type={'box'}
                    />
                </div>
                <div className="reSendCode">
                    <div onClick={()=>{
                        if(this.state.clickSend){
                            imgCodeAlert({
                                type: "success",
                                title : React.language('verification.img.code'),
                                value : this.state.value,
                                mode: mode
                            })
                        }
                    }} className={clickSend ? "SendBtn" : "SendBtn unSend"}>
                        {clickSend ? React.language('resubmit') : React.language('m.code.send.seconds',{time:this.state.time})}
                    </div>
                </div>
            </div>
        );
    }
}

export default EntryInputCode;